// Max width (px) requested for images embedded in the application-portfolio
// preview. The whole document is inlined as base64 and posted to the backend for
// PDF rendering, so keeping the source small keeps that payload well within the
// server's request-size limit. A4 at 96dpi is 794px wide, so 1000px leaves
// retina headroom while a raw phone photo (often several MB) would not.
export const PORTFOLIO_PREVIEW_IMAGE_WIDTH = 1000
